define('home/views/ChannelLeadersModuleView',[
    'underscore',

    'home/views/common/TabbedView',
    'home/views/ChannelLeadersCollectionView',

    'home/templates/channelLeadersModule',
], function (
    _,

    TabbedView,
    ChannelLeadersCollectionView,

    channelLeadersModuleTemplate
) {
    'use strict';

    /**
     * The module view shown for a channel showing a list of top
     * contributors and/or mods for the channel.
     */
    var ChannelLeadersModuleView = TabbedView.extend({
        className: function () {
            return this.expanded ? '' : 'collapsed';
        },

        defaultTab: function () {
            if (this.model.moderators.items.length && !this.model.leaders.items.length)
                return 'mods';

            return 'leaders';
        },

        template: channelLeadersModuleTemplate,
        templateHelpers: function () {
            return {
                numMods: this.model.moderators.items.length,
            };
        },

        events: _.defaults({
            'click [data-action=expand-module]': 'expandModule',
        }, TabbedView.prototype.events),

        regions: _.defaults({
            // Overwrite content region selector from tabbed view since this module is
            // nested in another tabbed view and has a different content region selector
            // so as to not collide with another content region selector.
            contentRegion: '[data-role=leaders-content-area]',
        }, TabbedView.prototype.events),

        ui: {
            footer: '[data-role=footer]',
        },

        initialize: function (options) {
            TabbedView.prototype.initialize.call(this, _.extend({
                isModule: true,
            }, options));

            var boundRender = _.bind(this.render, this);
            this.model.ensureFetchedLeaders().then(boundRender);
            this.model.ensureFetchedModerators().then(boundRender);

            this.listenTo(this, 'change:activeTab render', this.updateFooter);
        },

        /**
         * Expands any collapsed items in this module across all tabs. Once the
         * module is expanded on either tab, it remains expanded.
         */
        expandModule: function () {
            this.expanded = true;
            this.$el.attr('class', this.className());
            this.updateFooter();
        },

        /**
         * Shows or hides the expand option in the footer depending on whether or not
         * the current tab contains enough items so that some are collapsed.
         */
        updateFooter: function () {
            var collection = this.getTabCollection(this.activeTab || _.result(this, 'defaultTab'));
            var shouldHideFooter = this.expanded || collection.length <= this.constructor.COLLAPSED_SIZE;
            this.ui.footer.toggleClass('hidden', shouldHideFooter);
        },

        /**
         * Returns the user collection from the backing model that should be shown
         * depending on which tab we're currently viewing.
         * @param  {string} activeTab - Which tab is being viewed, either leaders or mods
         * @returns {UserCollection}
         */
        getTabCollection: function (activeTab) {
            var contentName = this.constructor.TAB_CONTENT[activeTab];
            if (contentName)
                return this.model[contentName].items;
        },

        getTabView: function (activeTab) {
            var tabCollection = this.getTabCollection(activeTab);
            if (!tabCollection)
                return;

            return new ChannelLeadersCollectionView({
                collection: tabCollection,
                model: this.model,
                collapsedSize: this.constructor.COLLAPSED_SIZE,
                type: activeTab,
            });
        },
    }, {
        TAB_CONTENT: {
            leaders: 'leaders',
            mods: 'moderators',
        },

        COLLAPSED_SIZE: 5,
    });

    return ChannelLeadersModuleView;
});

